import React from "react";
import * as api from "../../api/skyduck";
import {getDictionaries, setJumpNumbersSet} from "../../storage/user";
import {convertTimestampToDate, getYearFromTimestamp} from "../../util/time";
import MainWrapper from "../menu/main";
import {PrintLogbook} from "./print-logbook";
import {Units} from "../menu/units";
import {JumpsTable} from "./jumps";
import * as ReactGA from "react-ga";
import {calculateStatistics, Statistics} from "./util/statistics";

function getJumpsNumbersSet(jumps) {
    let jumpsNumbers = jumps.map(jump => {
        return jump.jumpNumber
    });
    setJumpNumbersSet(jumpsNumbers);
    return new Set(jumpsNumbers);
}

class JumpsScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            jumps: [],
            statistics: new Statistics(),
            jumpNumbersSet: null
        };
    }

    async componentDidMount() {
        await api.dictionaries();

        let jumps = await api.getJumps();
        let jumpsNumbersSet = getJumpsNumbersSet(jumps);

        let statistics = calculateStatistics(jumps);

        jumps = jumps.map(jump => {
            jump.groupKey = convertTimestampToDate(jump.date);

            jump.iconIDs = jump.icons;
            delete jump.icons;

            // TODO Ask Igor to add IDs to icons
            jump.iconIDs = jump.iconIDs.map(icon => {
                let iconId = null;
                let iconGroups = getDictionaries().jumpIcons.map(group => group.icons);
                iconGroups.forEach(iconGroupToCheck => {
                    iconGroupToCheck.forEach(iconToCheck => {
                        if(iconToCheck.iconURL === icon.url) {
                            iconId = iconToCheck._id;
                        }
                    })
                })
                return {
                    name: icon.name,
                    url: icon.url,
                    // TODO This is hotfix
                    id: iconId
                }
            })
            // TODO Ask Igor to add IDs to icons

            return jump;
        })

        let groupBy = function(jumps, key) {
            return jumps.reduce(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };

        this.setState({
            loading: false,
            jumps: Object.values(groupBy(jumps, 'groupKey')),
            statistics: statistics,
            jumpNumbersSet: jumpsNumbersSet
        });
    }

    render() {
        ReactGA.pageview('/');
        return (
            <MainWrapper menu={<Menu/>} content={<Content {...this}/>}/>
        );
    }
}

function Menu() {
    return (
        <>
            <h3 className="skyduck-color">Logbook</h3>

            <p>You can export your logbook in printable PDF format.</p>
            <p>Printed logbook conforms USPA SIM 3.1C.</p>
            <PrintLogbook/>

            <div className="mt-3 mb-3">
                <Units/>
            </div>
        </>
    );
}

function Content(props) {
    return (
        <>
            {props.state.loading ? <LoadingSpinner/> : <JumpsTable {...props}/>}
        </>
    );
}

function LoadingSpinner() {
    return (
        <>
            <p>Loading your jumps, it could take a while.</p>
            <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading your jumps, it could take a while.</span>
            </div>
        </>
    );
}

export default JumpsScreen;